import { useState, useEffect } from "react";
import axios from "axios";

function Login() {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  // =====================================================
  // BACKGROUND SLIDES
  // =====================================================

  const backgroundImages = [
    "/images/school1.jpg",
    "/images/school2.jpg",
    "/images/school3.jpg",
    "/images/school4.jpg",
    "/images/school5.jpg",
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {

    const interval = setInterval(() => {

      setCurrentImage((prev) =>
        (prev + 1) % backgroundImages.length
      );

    }, 5000);

    return () => clearInterval(interval);

  }, [backgroundImages.length]);

  // =====================================================
  // LOGIN
  // =====================================================

  const handleLogin = async (e) => {

    e.preventDefault();

    setError("");

    setLoading(true);

    try {

      const res = await axios.post(
        "https://api.eduskot.com/api/auth/login/",
        {
          username,
          password,
        }
      );

      localStorage.setItem("access", res.data.access);

localStorage.setItem("refresh", res.data.refresh);

localStorage.setItem("role", res.data.role);

localStorage.setItem("username", res.data.username);

localStorage.setItem(
  "is_dean",
  res.data.is_dean
);

      const role = res.data.role;

      if (role === "ADMIN") {

        window.location.href = "/admin-dashboard";

      } else if (role === "TEACHER") {

        window.location.href = "/teacher-dashboard";

      } else if (role === "STUDENT") {

        window.location.href = "/student-home";

      } else {

        setError("Unknown user role");
      }

    } catch (err) {

      setError("Invalid username or password");

    } finally {

      setLoading(false);
    }
  };

  return (

    <div
      style={{
        ...styles.page,

        backgroundImage: `
          linear-gradient(
            rgba(2,6,23,0.18),
            rgba(2,6,23,0.35)
          ),
          url(${backgroundImages[currentImage]})
        `,
      }}
    >

      {/* OVERLAY */}

      <div style={styles.overlay}></div>

      {/* LOGO */}

      <div style={styles.logoWrapper}>

        <img
          className="login-logo"
          src="/images/eduskot-text-logo.png"
          alt="eduSkot"
          style={styles.logo}
        />

      </div>

      {/* LOGIN CARD */}

      <div
        className="login-card"
        style={styles.card}
      >

        <h2
          className="login-title"
          style={styles.title}
        >
          College Bilingue
          <br />
          Bonchouo
        </h2>

        <p
          className="login-subtitle"
          style={styles.subtitle}
        >
          Sign in to continue
        </p>

        <form
          onSubmit={handleLogin}
          style={styles.form}
        >

          <input
            className="login-input"
            style={styles.input}
            type="text"
            placeholder="Username (Admission Number)"
            value={username}
            onChange={(e) =>
              setUsername(e.target.value)
            }
            required
          />

          <input
            className="login-input"
            style={styles.input}
            type="password"
            placeholder="Password (Date of Birth)"
            value={password}
            onChange={(e) =>
              setPassword(e.target.value)
            }
            required
          />

          <button
            className="login-button"
            style={styles.button}
            type="submit"
            disabled={loading}
          >

            {
              loading
                ? "Signing in..."
                : "Login"
            }

          </button>
            
        </form>

        {error && (

          <p style={styles.error}>
            {error}
          </p>

        )}

      </div>

      <div style={styles.footer}>
        © 2025 eduSkot. All rights reserved.
      </div>

      {/* STYLES */}

      <style>
        {`

          @keyframes fadeIn {

            from {
              opacity: 0;
              transform: translateY(20px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes heartbeat {

            0% {
              transform: scale(1);
            }

            15% {
              transform: scale(1.06);
            }

            30% {
              transform: scale(1);
            }

            45% {
              transform: scale(1.06);
            }

            70% {
              transform: scale(1);
            }

            100% {
              transform: scale(1);
            }
          }

          /* ================================================= */
          /* MOBILE RESPONSIVE */
          /* ================================================= */

          @media (max-width: 768px) {

            .login-card {

              width: calc(100vw - 40px) !important;

              max-width: 320px !important;

              padding: 28px 22px !important;

              margin-top: 0 !important;

              border-radius: 24px !important;
            }

            .login-title {

              font-size: 22px !important;

              line-height: 1.25 !important;
            }

            .login-subtitle {

              font-size: 14px !important;

              margin-bottom: 22px !important;
            }

            .login-input {

              padding: 14px !important;

              font-size: 14px !important;
            }

            .login-button {

              padding: 14px !important;

              font-size: 15px !important;
            }

            .login-logo {

              width: 90px !important;

              height: 90px !important;
            }
          }

        `}
      </style>

    </div>
  );
}

const styles = {

  // =====================================================
  // PAGE
  // =====================================================

  page: {

    minHeight: "100vh",

    width: "100%",

    display: "flex",

    justifyContent: "center",

    alignItems: "center",

    position: "relative",

    backgroundSize: "cover",

    backgroundPosition: "center",

    backgroundRepeat: "no-repeat",

    transition:
      "background-image 1.5s ease-in-out",

    overflowX: "hidden",
    boxSizing: "border-box",

    padding: "0",

    fontFamily:
      "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
  },

  // =====================================================
  // OVERLAY
  // =====================================================

  overlay: {

    position: "absolute",

    inset: 0,

    background:
      "linear-gradient(rgba(2,6,23,0.10), rgba(2,6,23,0.22))",
  },

  // =====================================================
  // LOGO
  // =====================================================

  logoWrapper: {

    position: "absolute",

    top: "20px",

    left: "20px",

    zIndex: 3,

    animation:
      "heartbeat 5s ease-in-out infinite",
  },

 footer: {

    position: "fixed",

    bottom: "12px",

    left: "50%",

    transform: "translateX(-50%)",

    zIndex: 5,

    color: "white",

    fontSize: "13px",

    fontWeight: "500",

    textShadow:
      "0 2px 8px rgba(0,0,0,0.5)",

    textAlign: "center",

    width: "100%",
  },

  logo: {

    width: "95px",

    height: "95px",

    borderRadius: "50%",

    objectFit: "cover",

    background: "white",

    padding: "4px",

    border: "3px solid rgba(255,255,255,0.9)",

    boxShadow:
      "0 10px 25px rgba(0,0,0,0.25)",
  },

  // =====================================================
  // LOGIN CARD
  // =====================================================

  card: {

    position: "relative",

    zIndex: 2,

    width: "90%",

    maxWidth: "420px",

    marginTop: "40px",

    background:
      "rgba(255,255,255,0.20)",

    border:
      "1px solid rgba(255,255,255,0.25)",

    backdropFilter: "blur(12px)",

    padding: "42px 34px",

    borderRadius: "28px",

    boxShadow:
      "0 20px 50px rgba(0,0,0,0.22)",

    textAlign: "center",

    animation:
      "fadeIn 1s ease",
  },

  title: {

    marginBottom: "10px",

    color: "white",

    fontSize: "42px",

    fontWeight: "700",

    lineHeight: "1.2",

    textShadow:
      "0 2px 10px rgba(0,0,0,0.20)",
  },

  subtitle: {

    marginBottom: "30px",

    color: "#f8fafc",

    fontSize: "16px",
  },

  form: {

    display: "flex",

    flexDirection: "column",

    gap: "16px",
  },

  input: {

    padding: "16px",

    borderRadius: "14px",

    border:
      "1px solid rgba(255,255,255,0.10)",

    fontSize: "15px",

    outline: "none",

    background: "rgba(255,255,255,0.96)",

    color: "#0f172a",

    transition:
      "0.3s ease",
  },

  button: {

    marginTop: "6px",

    padding: "16px",

    borderRadius: "14px",

    border: "none",

    background:
      "linear-gradient(135deg,#2563eb,#7c3aed)",

    color: "white",

    fontWeight: "700",

    fontSize: "16px",

    cursor: "pointer",

    transition:
      "0.3s ease",

    boxShadow:
      "0 10px 25px rgba(37,99,235,0.35)",
  },

  error: {

    marginTop: "16px",

    color: "#fee2e2",

    fontSize: "14px",
  },
};

export default Login;